// Fallback defaults double as the production values — CI does not pass
// VITE_* vars at build time, so whatever lands here gets baked into the
// shipped bundle. Domain lineage, each flip moving only the literal and
// preserving the apex/sub split: `rmsystems.dev` → `avantfunded.com`
// (Phase DM-AVANT, 2026-05-14) → `flex-fund.com` (Flex Fund rebrand,
// 2026-07-29).
export const env = {
  publicDomain: import.meta.env.VITE_PUBLIC_DOMAIN ?? "https://flex-fund.com",
  registerUrl: import.meta.env.VITE_TRADER_REGISTER_URL ?? "https://trade.flex-fund.com/challenge",
  loginUrl: import.meta.env.VITE_TRADER_LOGIN_URL ?? "https://trade.flex-fund.com/login",
  traderFaqUrl: import.meta.env.VITE_TRADER_FAQ_URL ?? "https://trade.flex-fund.com/faq",
  legalPrivacyUrl: import.meta.env.VITE_LEGAL_PRIVACY_URL ?? "https://trade.flex-fund.com/privacy-policy",
  legalTermsUrl: import.meta.env.VITE_LEGAL_TERMS_URL ?? "https://trade.flex-fund.com/terms-and-conditions",
  // Google Programmable Search Engine ID. Public identifier (appears in
  // the WebSite JSON-LD's SearchAction target and the /search redirect
  // URL). The actual search scope is configured operator-side at
  // programmablesearchengine.google.com under this CX and, as of
  // 2026-07-29, is still `avantfunded.com + trade.avantfunded.com` —
  // it does NOT move with this repo's domain flip, so /search returns
  // results for the dead site until the operator updates it. Change
  // this comment when the CSE is re-scoped, not before (see
  // docs/rebrand-literals.md row 13, and src/lib/cse.ts).
  cseCxId: "d7f1680449eed4a84",
} as const;
